/**
 * @generated SignedSource<<a24fb3c7b586fd8276ccb79ab2f1eed3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_user" | "PdpRespTradeIconBubbles_user">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_user";
};
export type PdpRespIconBubblesWrapper_user$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "19f3057534586ba1d5fd5bcf9624e8ef";

export default node;
